import {
  CasRouterTabWrapper,
  IRouterTabItem,
  IRouterTabsObject,
} from 'src/compass/shared/components/CasTabsView/CasRouterTabs';

export interface ITabRoutes {
  element: JSX.Element | null;
  index?: boolean;
  path?: string;
  children?: ITabRoutes[];
}

function wrap({ label, children }: IRouterTabItem) {
  return <CasRouterTabWrapper label={label}>{children}</CasRouterTabWrapper>;
}

export function TabListToRouteList(tabsObj: IRouterTabsObject): ITabRoutes[] | undefined {
  if (tabsObj === undefined) return undefined;

  const tabList = tabsObj.tabs;
  return [
    { index: true, element: tabsObj.noDefault ? null : wrap(tabList[0]) },

    ...tabList.map((tab) => ({
      path: tab.path ?? tab.label.replace(' ', ''),
      element: wrap(tab),
      children: tab.nested ? TabListToRouteList(tab.nested) : undefined,
    })),
  ];
}
